<template>
  <div>
    <v-data-table :headers="headersEndereco" :items="devedor.enderecos?devedor.enderecos:[]">
      <template v-slot:item="props">
        <tr :class="getColorEndereco(props.item)">
          <td>{{props.item.logradouro}}</td>
          <td>{{props.item.numero}}</td>
          <td>{{props.item.bairro}}</td>
          <td>{{props.item.localidade}}</td>
          <td>{{props.item.uf}}</td>
          <td>
            <v-icon
              small
              class="mr-2"
              @click="editItem(props.item)">
              edit
            </v-icon>
            <v-icon
              small
              v-show="user.acesso == 'Admin'"
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </td>
        </tr>
      </template>
      
    </v-data-table>

    <div class="my-2">
      <v-btn small @click.native="novoEndereco(devedor)" color="primary">Novo Endereço</v-btn>
    </div>
    <v-dialog v-model="dialogEndereco" persistent max-width="800">
      <v-card>
        <v-card-title class="headline">Novo Endereço</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
              <v-row>
                <v-col sm="6">
                  <v-text-field 
                    label="Cep" 
                    v-model="modelEndereco.cep" 
                    placeholder="#####-###"
                    v-on:blur="freteCep(modelEndereco.cep)" 
                    v-mask="mask" required />
                </v-col>
                <v-col sm="6">
                  <v-text-field label="Logradouro" v-model="modelEndereco.logradouro" required />
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="6">
                  <v-text-field label="Numero" type="number" v-model="modelEndereco.numero" required />
                </v-col>
                <v-col sm="6">
                  <v-text-field label="Bairro" v-model="modelEndereco.bairro" required />
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="6">
                  <v-text-field label="Localidade" v-model="modelEndereco.localidade" required />
                </v-col>
                <v-col sm="6">
                  <v-text-field label="UF" v-model="modelEndereco.uf" required />
                </v-col>
              </v-row>
              
              <v-row>
                <v-col sm="12">
                  <v-text-field label="Complemento" type="text" v-model="modelEndereco.complemento" required />
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="12">
                  <v-checkbox label="Hot" v-model="modelEndereco.hot" />
                </v-col>
              </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="blue darken-1" @click.native="salvarEndereco()">Salvar</v-btn>
          <v-btn small color="red darken-1" @click.native="dialogEndereco = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="dialogConfirmation" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Confirmação</v-card-title>
        <v-card-text>Tem certeza que deseja excluir?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-1" @click.native="dialogConfirmation = false">Não</v-btn>
          <v-btn small color="blue darken-1" @click.native="deleteItem(excluindo)">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
  import buscacep from "@/services/buscacep";
  import enderecodeve from "@/services/enderecodeve";
  import devedores from "@/services/devedores";
  import usuario from "@/services/usuario"; 
  import { mapMutations } from "vuex";  

  export default {
    name: 'Endereco',
    data () {
      return {
        
        valid: true,
        modelEndereco: {},
        dialogConfirmation:false,
        dialogEndereco: false,
        editando: false,
        excluindo: {},
        cep: {},
        user: {},
        mask: '#####-###',
        headersEndereco: [
          {
            text: 'Endereco',
            align: 'left',
            sortable: true,
            value: 'logradouro'
          },
          {
            text: 'Número',
            align: 'left',
            sortable: true,
            value: 'numero'
          },
          {
            text: 'Bairro',
            align: 'left',
            sortable: true,
            value: 'bairro'
          },
          {
            text: 'Cidade',
            align: 'left',
            sortable: true,
            value: 'localidade'
          },
          {
            text: 'UF',
            align: 'left',
            sortable: true,
            value: 'uf'
          },
          { text: 'Ações', value: 'action', sortable: false }
        ],
        estados: ["Acre",
                "Amapá",
                "Amazonas",
                "Pará",
                "Rondônia",
                "Roraima",
                "Tocantins",
                "Alagoas",
                "Bahia",
                "Ceará",
                "Maranhão",
                "Paraíba",
                "Pernambuco",
                "Piauí",
                "Rio Grande do Norte",
                "Sergipe",
                "Goiás",
                "Mato Grosso",
                "Mato Grosso do Sul",
                "Distrito Federal",
                "Espiríto Santo",
                "Rio de Janeiro",
                "São Paulo",
                "Minas Gerais",
                "Paraná",
                "Rio Grande do Sul",
                "Santa Catarina"],
      }
    },
    async mounted () {
      this.user = await usuario.getUsuario(this.$store.getters.user._id);
    },
    computed: {
      devedor() {
        return this.$store.getters["devedor"];
      },
    },
    methods: {
      novoEndereco (devedor) {
        this.modelEndereco = {devedor: devedor._id};
        this.dialogEndereco = true;
      },
      async salvarEndereco () {
      if (this.$refs.form.validate()) {
        await enderecodeve.save(this.modelEndereco);
        this.dialogEndereco = false;
          this.setDevedor(await devedores.getDevedoreId(this.modelEndereco.devedor));
        this.$forceUpdate();
      }
      },
      
      async freteCep (postcode) {
        this.cep = await buscacep.getCep(postcode.replace('-', ''));

        this.modelEndereco.logradouro = this.cep.logradouro;
        this.modelEndereco.bairro = this.cep.bairro;
        this.modelEndereco.localidade = this.cep.localidade;
        this.modelEndereco.uf = this.cep.uf;
        this.$forceUpdate();
      },
      getColorEndereco (endereco) {
        if (endereco && endereco.hot) return 'red white--text';
      },
      deleteItem: async function (even) {
        if (!this.dialogConfirmation) {
          this.dialogConfirmation = true;
          this.excluindo = even;
        } else {
          await enderecodeve.remove(even);
          this.dialogConfirmation = false;
          this.excluindo = null;
          this.setDevedor(await devedores.getDevedoreId(even.devedor));
        }
      },
      editItem: async function (even) {
        
        this.dialogEndereco = true;
        this.editando = true;
        this.modelEndereco = even;
        
        this.modelEndereco.internal = undefined;
        this.modelEndereco.flags = undefined;
      },
      ...mapMutations({
        setDevedor: "setDevedor",
      })
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/cobranca/Endereco.vue